import {
  attributeGroup,
  enumBuckets,
  pointLayer,
  stringAttr,
  unsafeMapId,
  unsafeMapLayerId,
} from "@cartographerio/atlas-map";
import {
  MrsMudSpotterFlowEnum,
  MrsMudSpotterSedimentEnum,
  MrsMudSpotterSourceSizeEnum,
  MrsMudSpotterSourceSubTypeEnum,
  MrsMudSpotterSourceTypeEnum,
} from "@cartographerio/inventory-enums";
import {
  cartographerMapSourceWithDefaults,
  mapSchemaWithDefaults,
} from "../../core";

export const MrsMudSpotter = mapSchemaWithDefaults({
  mapId: unsafeMapId("MrsMudSpotter"),
  title: "Mud Spotter",
  layers: [
    pointLayer({
      layerId: unsafeMapLayerId("MrsMudSpotter"),
      title: "Mud Spotter",
      source: cartographerMapSourceWithDefaults({
        layerId: unsafeMapLayerId("MrsMudSpotter"),
        attribution: [],
      }),
      defaultAttribute: "sourceType",
      attributes: [
        attributeGroup({
          label: "Site",
          attributes: [
            stringAttr({
              attributeId: "siteName",
              label: "Site Name",
              buckets: "auto",
            }),
          ],
        }),
        attributeGroup({
          label: "Source",
          attributes: [
            stringAttr({
              attributeId: "riverName",
              label: "River",
              buckets: "auto",
            }),
            stringAttr({
              attributeId: "reachName",
              label: "Reach",
              buckets: "auto",
            }),
            stringAttr({
              attributeId: "siteName",
              label: "Site",
              buckets: "auto",
            }),
            stringAttr({
              attributeId: "sourceType",
              label: "Source Type",
              buckets: enumBuckets(MrsMudSpotterSourceTypeEnum),
            }),
            stringAttr({
              attributeId: "sourceSubType",
              label: "Source Sub-Type",
              buckets: enumBuckets(MrsMudSpotterSourceSubTypeEnum),
            }),
            stringAttr({
              attributeId: "sourceSize",
              label: "Source Size",
              buckets: enumBuckets(MrsMudSpotterSourceSizeEnum),
            }),
            stringAttr({
              attributeId: "flow",
              label: "Flow of Water",
              buckets: enumBuckets(MrsMudSpotterFlowEnum),
            }),
            stringAttr({
              attributeId: "sediment",
              label: "Mud in Flowing Water",
              buckets: enumBuckets(MrsMudSpotterSedimentEnum),
            }),
          ],
        }),
      ],
    }),
  ],
});
